export enum NotiButtonState {
  Default = 'Default',
  Processing = 'Processing',
  Subscribed = 'Subscribed',
  Hidden = 'Hidden',
  None = 'None',
}
